var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9149 27.3072C28.1711 27.5915 27.7663 27.9981 27.4791 28.7407C27.1943 27.9981 26.7871 27.5939 26.0433 27.3072C26.7871 27.0228 27.1919 26.6186 27.4791 25.8736C27.7639 26.6163 28.1711 27.0205 28.9149 27.3072ZM27.5827 15.6814C28.2276 13.2844 29.1079 12.4031 31.5111 11.7592C29.1103 11.1152 28.2276 10.2363 27.5827 7.83691C26.9377 10.234 26.0574 11.1152 23.6542 11.7592C26.0551 12.4031 26.9377 13.282 27.5827 15.6814ZM28.2841 20.6283C28.2841 20.4027 28.1664 20.1301 27.8369 20.0384C25.1442 19.2864 23.4565 18.4286 22.1972 17.1714C20.938 15.9141 20.0765 14.2291 19.3256 11.5406C19.2338 11.2116 18.9608 11.0941 18.7348 11.0941C18.5089 11.0941 18.2358 11.2116 18.144 11.5406C17.3908 14.2291 16.5317 15.9141 15.2724 17.1714C14.0108 18.431 12.3255 19.2888 9.63276 20.0384C9.30324 20.1301 9.18555 20.4027 9.18555 20.6283C9.18555 20.8539 9.30324 21.1265 9.63276 21.2182C12.3255 21.9702 14.0131 22.828 15.2724 24.0852C16.534 25.3449 17.3932 27.0275 18.144 29.716C18.2358 30.045 18.5089 30.1625 18.7348 30.1625C18.9608 30.1625 19.2338 30.045 19.3256 29.716C20.0788 27.0275 20.938 25.3425 22.1972 24.0852C23.4589 22.8256 25.1442 21.9678 27.8369 21.2182C28.1664 21.1265 28.2841 20.8539 28.2841 20.6283Z",
    fill: "url(#paint0_linear_29634_63441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29634_63441",
    x1: 9.18555,
    y1: 18.9997,
    x2: 31.5111,
    y2: 18.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#30096E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.52dab5487279d1bc2b4182b923bbcdb5.svg";
export { ForwardRef as ReactComponent };